import { Paneset } from "@folio/stripes/components";
import React from "react";
import { panes } from "../utils/paneDefinitions";
export var RecekPaneSet = function (_a) {
    var children = _a.children;
    return (React.createElement(Paneset, { initialLayouts: panes }, children));
};
